import { Box, Flex } from '@chakra-ui/react';
import { ManagerDropdown } from '~/components/ManagerDropdown';
import {
  CreatorProfileDropdownMenu,
  RosterViewDropdownMenu,
} from '~/components/TalentDropdownMenu';
import { ICreator, ManagerShortType } from '~/types';

interface Props {
  creator: ICreator;
  isProfile?: boolean;
  isShared: boolean | undefined;
  note?: string;
  onNoteOpen?: () => void;
}

export const CreatorButtons: React.FC<Props> = ({
  creator,
  isProfile, // from Creator Profile page
  isShared,
  note,
  onNoteOpen,
}) => (
  <Flex justify="wrap" alignItems="center">
    <Box marginRight="auto">
      {!isShared ? (
        isProfile ? (
          <CreatorProfileDropdownMenu
            creator={creator}
            note={note}
            onNoteOpen={onNoteOpen}
            isShared={isShared}
          />
        ) : (
          <RosterViewDropdownMenu
            creator={creator}
            note={note}
            onNoteOpen={onNoteOpen}
            isShared={isShared}
          />
        )
      ) : (
        <ManagerDropdown
          manager={creator.manager as ManagerShortType}
          isShared={isShared}
        />
      )}
    </Box>
  </Flex>
);
